import type {Door} from "@/dungeons/model/DungeonGeometry.ts";

export type DoorState = "OPEN" | "CLOSED";

export type EncounterDoorState = {
    doorId: string;
    state: DoorState;
};

export const effectiveDoorState = (
    door: Door,
    overrides: ReadonlyMap<string, DoorState>,
): DoorState => overrides.get(door.id) ?? door.initialState;
